import {api} from "../Api/api";

class ScannerUtils {
    static extractToken(url: string) {
        try {
            const parsed = new URL(url);
            if (parsed.search || parsed.hash) return undefined;

            const parts = parsed.pathname.split('/').filter(Boolean);

            if (parts.length === 1) {
                return parts[0];
            }

            return undefined;
        } catch {
            return undefined;
        }
    }
}

export default ScannerUtils;